export const NAVIGATOR_OPEN_PANEL = '@navigator/open-panel';
export const NAVIGATOR_OPEN_VIEW = '@navigator/open-view';
